// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"a42e53c2cf9f7692","931":"6b44f5f32611addc"}[chunkId] + ".css";
};